export var SubdivisionType;
(function (SubdivisionType) {
    SubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    /** State */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    /** County */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    /** City/town */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    /** Neighborhood/quarter */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    /** Street/block */
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
    /** ADMINISTRATIVE_AREA_LEVEL_0. Indicates the national political entity, and is typically the highest order type returned by the Geocoder. */
    SubdivisionType["COUNTRY"] = "COUNTRY";
})(SubdivisionType || (SubdivisionType = {}));
export var TraderType;
(function (TraderType) {
    TraderType["UNKNOWN_TRADER_TYPE"] = "UNKNOWN_TRADER_TYPE";
    TraderType["COMPANY"] = "COMPANY";
    TraderType["FREELANCER"] = "FREELANCER";
})(TraderType || (TraderType = {}));
export var BusinessType;
(function (BusinessType) {
    BusinessType["UNKNOWN_BUSINESS_TYPE"] = "UNKNOWN_BUSINESS_TYPE";
    BusinessType["LLC"] = "LLC";
    BusinessType["PRIVATELY_OWNED_BUSINESS"] = "PRIVATELY_OWNED_BUSINESS";
    BusinessType["PARTNERSHIP"] = "PARTNERSHIP";
    BusinessType["OTHER"] = "OTHER";
})(BusinessType || (BusinessType = {}));
export var ValidationStatus;
(function (ValidationStatus) {
    ValidationStatus["UNKNOWN_VALIDATION_STATUS"] = "UNKNOWN_VALIDATION_STATUS";
    ValidationStatus["VALID"] = "VALID";
    ValidationStatus["NOT_VALID"] = "NOT_VALID";
    ValidationStatus["PENDING_VALIDATION"] = "PENDING_VALIDATION";
    ValidationStatus["OPTED_OUT"] = "OPTED_OUT";
})(ValidationStatus || (ValidationStatus = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
//# sourceMappingURL=types.impl.js.map